import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Import Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Konfiguracja Vuetify z ciemnym motywem
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        dark: true,
        colors: {
          primary: '#1E88E5', // Kolor główny
          secondary: '#424242', // Kolor dodatkowy
          background: '#121212', // Tło
          surface: '#1E1E1E', // Powierzchnie
          error: '#CF6679', // Kolor błędu
        },
      },
    },
  },
});

const app = createApp(App);
app.use(router);
app.use(vuetify); // Użyj Vuetify
app.mount('#app');